import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useT } from '../../context/TenantContext';

export default function TrackForm() {
  const { t } = useT();
  const [ref, setRef] = useState('');
  const navigate = useNavigate();
  return (
    <div className="fd-track-form">
      <input className="fd-input" placeholder="TKT-XXXXX" value={ref} onChange={e=>setRef(e.target.value.toUpperCase())} />
      <button className="fd-track-btn" type="button" onClick={()=>ref&&navigate(`/ticket/${ref}`)}>{t('fd.consult')}</button>
    </div>
  );
}
